//https://www.codemzy.com/blog/fix-chunkloaderror-react
import { ComponentType } from 'react';

import { getCheck24Namespace } from 'utility/Provide/Namespace/getCheck24Namespace';

import { GlobalNamespace } from 'types/legacy/namespace';

const sessionStorageKey = 'retry-lazy-error-handled';
const ns = getCheck24Namespace() as GlobalNamespace;
const backendInformation = ns.components.backendInformationFunc;

window.sessionStorage.setItem(sessionStorageKey, 'false');

export const resetInfo = () => {
    window.sessionStorage.setItem(sessionStorageKey, 'false'); // success so reset the refresh
};

resetInfo();

interface ComponentExport<T> {
    default: T;
}

// any required because of internal react typing
// eslint-disable-next-line
export const lazyRetry = <T extends ComponentType<any>>(
    componentImport: () => Promise<ComponentExport<T>>
): Promise<ComponentExport<T>> => {
    return new Promise((resolve) => {
        // check if the window has already been refreshed
        // try to import the component
        componentImport()
            .then((component) => {
                resolve(component);
            })
            .catch(() => {
                const hasErrorHandled = JSON.parse(
                    window.sessionStorage.getItem(sessionStorageKey) || 'false'
                );
                if (!hasErrorHandled) {
                    // not been refreshed yet
                    window.sessionStorage.setItem(sessionStorageKey, 'true'); // we are now going to refresh
                    backendInformation.trigger('js-file-could-not-load', {
                        message: 'chunk could not be loaded',
                        lazyChunkError: true,
                    });
                }
            });
    });
};
